export default __webpack_public_path__ + "static/media/medical.25403cca.jpg";